module.exports = __webpack_public_path__ + "img/logo-hen.39113cc6.png";